import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './RoomEditorV2.html?raw';
import on from 'dojo/on';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";
import lang from 'dojo/_base/lang';
import MultiselectBox from '../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import MainCatalogSelectV2 from '../MainCatalogSelectV2';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import EntityStore from '../../../moreCore/Tools/EntityStore';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import AudienceSeatingLayoutEntryV2 from './AudienceSeatingLayoutEntry/AudienceSeatingLayoutEntryV2';






interface EvServiceEntry {
    serviceID: string;
    serviceColor: more.EntityAPIColor;
    assignmentID: string;
    description: string;
    isDeleted?: boolean;
    blobNode?: HTMLElement;
    blobIcon?: HTMLElement;
}
class RoomEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    input_Services: MdsLax<InstanceType<typeof MultiselectBox>>;
    inputServicesContainer: HTMLElement;
    selectedServicesContainer: HTMLElement;

    venueSelect: MdsLax<InstanceType<typeof MainCatalogSelectV2>>;
    selectContainer: HTMLDivElement;


    selectedServices: Array<EvServiceEntry> = [];

    seatingLayoutExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    seatingLayoutStore: MdsLax<InstanceType<typeof EntityStore<MainCatalogTypes.AudienceSeatingLayoutsEditor_SaveData>>>;
    seatingLayouTable: MdsLax<InstanceType<typeof StaticTable>>;

    tableRowLayout: StaticTable.RowConfig = {
        attributes: [ "code", "description", "seating_capacity"],
        colNamesInternal: ["code", "description", "seating_capacity"],
        headings: [(this as any).translate("General_Label_Code"), (this as any).translate("General_Label_Description"), (this as any).translate("General_Label_SeatingCapacity")],
    }

    tableLayout: StaticTable.Layout = {
        label: "seatingLayoutTable",
        name: "seatingLayoutTable",
        rows: [(this as any).tableRowLayout],
    }

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);
        this.selectedServices = lang.clone(this.getAttributeValue("evServices"));

        let presetValues = this.selectedServices.map(entry => { return entry.serviceID });
        
        
        this.input_Services.setValue(presetValues, true);
        this._onChangeInput_Services(presetValues);

        this.drawSelectedCategoryBlobs();

        var venue = this.getAttributeValue("ref_venue.ID");

        this.venueSelect.setCatalog(MainCatalogs_Classes.Venues,
            this.translations["General_Label_Venues"], venue);

        var seatingLayouts = this.getAttributeValue("audience_seating_layouts");
        this.seatingLayoutStore.setup(seatingLayouts);
        this.seatingLayouTable.setupFromStore(this.seatingLayoutStore);
        this.seatingLayoutExpander.setMarking(seatingLayouts.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

    }

    private _setupTable(): void {
        this.seatingLayouTable = new StaticTable();
        this.seatingLayouTable.addLayout(this.tableLayout);
        this.seatingLayouTable.addDefaultRowActionButton("delete");
        this.seatingLayouTable.setRowClick(lang.hitch(this, this._onClickTableRow));
        this.seatingLayouTable.setupFromStore(this.seatingLayoutStore);
        this.seatingLayouTable.setCyAttribute("RoomEditorV2SeatingLayoutTable");

        this.seatingLayouTable.placeAt(this.seatingLayoutExpander);
    }

    private _onClickTableRow(e): void {

        var entity = e.rowGroup.entity;

        var editor = new AudienceSeatingLayoutEntryV2();
        editor.setEntry(false, entity);

        var dlg = new GenericDialog();
        dlg.keepOpen = true;
        dlg.show(editor, entity.$Displayname, null, null, "okcancel", lang.hitch(this, this._onDlgResponse, dlg, editor));
    }

    private _onClickButtonSeatingLayoutAdd(): void {
        var editor = new AudienceSeatingLayoutEntryV2();
        editor.setEntry(true);


        var dlg = new GenericDialog();
        dlg.keepOpen = true;
        dlg.show(editor, "MainCatalogsEditor_AudienceSeatingLayoutEntry_NewEntryHeader", null, null, "okcancel", lang.hitch(this, this._onDlgResponse, dlg, editor));
    }




    private _onDlgResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, editor: MdsLax<InstanceType<typeof AudienceSeatingLayoutEntryV2>>, response: number) {
        if (response === 1) {
            if (!editor.editor.isValid()) {
                this.showToast("Einige Pflichtfelder sind nicht ausgefüllt!");
                return;
            }
            if (editor.editor.formData.is_new_status) {
                this.seatingLayoutStore.addEntry(editor.editor.formData);
            } else {
                this.seatingLayoutStore.changeEntry(editor.editor.formData);
            }


            dlg.close();
        } else {
            dlg.close();
        }
    }

    private addServiceBlob(serviceAssignment: EvServiceEntry) {

        let blob = this.UiModder.domConstruct.create("div", {
            className: "flex_row_center round nowrap border w3-tooltip",
            order: 100
        }, this.selectedServicesContainer);

        let tooltip = this.UiModder.domConstruct.create("span", {
            style: "position:absolute;left:22px;bottom:16px; pointer-events:none;",
            class: "w3-text w3-tag w3-pale-yellow w3-round w3-animate-opacity w3-border",
            innerHTML: serviceAssignment.description
        }, blob);

        let blobX = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base mds-hover-dark warningTXT round",
            innerHTML: "<i class='fas fa-times'></i>"
        }, blob);
        on(blobX, "click", lang.hitch(this, this._onClick_RemoveService, serviceAssignment));


        // gelöscht?
        this.UiModder.domClass.toggle(blob, "strike w3-disabled", serviceAssignment.isDeleted === true);

        let blobLabel = this.UiModder.domConstruct.create("div", {
            className: "paddingSmall",
            style: "max-width: 250px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;",
            innerHTML: serviceAssignment.description
        }, blob);

        let colorHexBG = "#ffffff";
        let colorHexTXT = "#000000";
        if (serviceAssignment.serviceColor) {
            colorHexBG = serviceAssignment.serviceColor.BackColor?.Hex;
            colorHexTXT = serviceAssignment.serviceColor.TextColor?.Hex;
        }

        if (colorHexBG) {
            this.UiModder.domStyle.set(blob, "backgroundColor", colorHexBG);
        }

        if (colorHexTXT) {
            this.UiModder.domStyle.set(blobLabel, "color", colorHexTXT);
        }
    }

    private drawSelectedCategoryBlobs(data?: Array<EvServiceEntry>) {

        if (!data) {
            data = this.selectedServices;
        }

        this.UiModder.domConstruct.empty(this.selectedServicesContainer);

        let servicesIds: Array<string> = [];

        if (data) {
            for (let assignedService of <Array<EvServiceEntry>>data) {
                // wir benötigen:
                // categoryIds (nicht assignment) für das Searchselect, damit die dort vorausgewählt sind
                // und wir erstellen die Blobs für schnellere Übersicht

                if (!assignedService.isDeleted) {
                    servicesIds.push(assignedService.serviceID);
                }

                this.addServiceBlob(assignedService);
            }
        }
    }

    private _onClick_RemoveService(targetAssignment: EvServiceEntry) {

        let selectedIDs: Array<string> = [];

        let deletedCategory = this.selectedServices.filter(x => x.serviceID === targetAssignment.serviceID)[0];

        deletedCategory.assignmentID ? deletedCategory.isDeleted = true : this.selectedServices.splice(this.selectedServices.indexOf(deletedCategory), 1);

        this.selectedServices.forEach(serviceAssignment => {

            if (serviceAssignment.isDeleted !== true) selectedIDs.push(serviceAssignment.serviceID);
        });

        this.input_Services.setValue(selectedIDs);
    }

    _onChangeInput_Services(newValues: Array<string>, origValues: { roomTypeId: string, venueId: string } = null /*servicePackGroupId?: string*/) {

        let entityValues = lang.clone(this.input_Services.getValue(true));
        let labelProp = this.input_Services.labelAttribute;
        let valueProp = this.input_Services.valueAttribute;

        let missingServices: Array<string> = [];
        let alreadySelectedServices: Array<string> = (<Array<EvServiceEntry>>this.selectedServices).map(function (assignment) {
            return assignment.serviceID;
        });

        let newAssignmentArray: Array<EvServiceEntry> = [];

        this.selectedServices.forEach(serviceAssignment => {

            if (serviceAssignment.assignmentID) {

                serviceAssignment.isDeleted = newValues.indexOf(serviceAssignment.serviceID) == -1;
            }

            if ((newValues.length > 0 && newValues.indexOf(serviceAssignment.serviceID) > -1) || serviceAssignment.isDeleted !== undefined) {

                newAssignmentArray.push(serviceAssignment);
            }
        });

        for (let entity of entityValues) {
            if (alreadySelectedServices.indexOf(entity[valueProp]) == -1) { // bisher noch nicht zugeordnet - neuer Eintrag!
                newAssignmentArray.push({
                    assignmentID: null,
                    serviceID: entity[valueProp],
                    serviceColor: entity.coloration,
                    description: entity[labelProp],
                });
            }
        }

        //this.formData.categories = newAssignmentArray;
        this.selectedServices = newAssignmentArray;
        this.setAttributeValue("evServices", lang.clone(this.selectedServices));

        this.drawSelectedCategoryBlobs();
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.EvRoom;
    }

    private _onChangeSelect(): void {
        var value = this.venueSelect.getValue();
        this.setAttributeValue("ref_venue", value, true);
    }

    private _onChangeStore(): void {
        var subGroupDiffData = this.seatingLayoutStore.getDiffData();
        this.setAttributeValue("seatingLayoutDiffData", subGroupDiffData);
        this.seatingLayoutExpander.setMarking(this.seatingLayoutStore.getCurrentCompleteList().length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    loadEvServicesMultiSelect(): void {

        let requestUrl = window.appRoot + "MainCatalogsEditor/GetEvServicesMultiSelectList";
        //this.StandbyStart();
        this.UiModder.domClass.add(this.inputServicesContainer, "egoAnimated_fadingHourglassOverlay w3-disabled");

        this.RequestManager.post(
            requestUrl,
            null,
            lang.hitch(this, this._onLoadEvServicesMultiSelectResult),
            lang.hitch(this, this._onLoadEvServicesMultiSelectError),
            false // sync
        );
    }

    _onLoadEvServicesMultiSelectResult(data: any): void {

        let preset: Array<string> = [];
        let alreadySelectedServices = (<Array<EvServiceEntry>>this.selectedServices).map(function (assignment) {
            return assignment.serviceID;
        });
        if (alreadySelectedServices.length > 0) preset = alreadySelectedServices;
        else preset = this.input_Services.getValue();

        //this.input_Services.setData(null, null, true);
        this.input_Services.setData(null, data, true);


        this.UiModder.domClass.remove(this.inputServicesContainer, "egoAnimated_fadingHourglassOverlay w3-disabled");
    }

    _onLoadEvServicesMultiSelectError(err: any): void {

        // TODO
        alert(err.Message);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        this.venueSelect = new MainCatalogSelectV2();

        this.venueSelect.placeAt(this.selectContainer);
        this.venueSelect.on("change", lang.hitch(this, this._onChangeSelect));

        this.venueSelect.setCatalog(MainCatalogs_Classes.Venues,
        this.translations["General_Label_Venues"]);

        this.seatingLayoutStore = new EntityStore();
        this.seatingLayoutStore.on("change", lang.hitch(this, this._onChangeStore));
        this._setupTable();



    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(RoomEditorV2);